import httpClient from "./httpClient";

const difService = {
  getDIFHours() {
    return httpClient.get("/api/adv/dif");
  },
  generateAttestationDIF() {
    return httpClient.get("/api/adv/dif/generate");
  }
};

export default difService;
